'use strict';

import {element_exists, redesignDataTablesHeader} from "../functions";
import {
    fnErrorMsg, fnToastrFormError, getSelectedCompany, handleErrors, printResponse,
    reloadVouchersTableWithMissingVoucherText, toggleLoader, validateCompany, validateVoucherLimit
} from "../jquery-functions-library";

export var uploadPdfs = function () {
    if (!element_exists('#btn-approve-all')) {
        return false;
    }

    $('#btn-approve-all').on('click', function (e) {

        var lang = allLangFiles.vouchers.js;

        var company_id = getSelectedCompany();
        var formData = {
            company_id: company_id
        };

        const tableName = '#datatable-vouchers';

        var dataTable = $(tableName).DataTable();
        var tableData = dataTable.data();

        var btnElement = '.btn-table-cell.btn-approve';

        uploadMoreVouchers(
            '/voucher/upload/all', formData, tableData, lang.upload_title, lang.upload_content, btnElement
        );
    });
};

export function uploadMoreVouchers(url, formData, tableData, title, content, rows) {

    var currentSum = 0;

    var lang = allLangFiles.vouchers.js;

    for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].no_voucher === 1 && tableData[i].PdfUploaded.indexOf('btn-approve') !== -1) {
            currentSum += Math.abs(tableData[i].Amount);
        }
    }

    var isOverLimit = false;
    var agreementHtml = validateVoucherLimit(lang, currentSum, function (overLimit) {
        isOverLimit = overLimit;
    });

    validateCompany(lang, {
        title: title,
        content: content + agreementHtml,
        theme: 'supervan',
        columnClass: 'col-md-12',
        backgroundDismiss: true,
        buttons: {

            formSubmit: {
                text: lang.yes,
                btnClass: 'btn-blue',
                action: function () {

                    if (isOverLimit) {
                        var isChecked = $('#accept-agreement').is(':checked');
                        if (!isChecked) {
                            $.alert(lang.limit_alert);
                            return false;
                        }
                    }

                    toggleLoader(rows, true);

                    $.ajax({
                        type: 'POST',
                        data: formData,
                        url: url,
                        success: function (response) {
                            console.log(response);

                            printResponse(response);

                            reloadVouchersTableWithMissingVoucherText();

                            handleErrors(response);
                        },
                        error: function(error){
                            fnToastrFormError(error);
                            reloadVouchersTableWithMissingVoucherText();
                        }
                    });
                }
            },
            Nej: {
                text: lang.no
            },
        }
    });
}

